import { inject, Injectable } from '@angular/core';
import { AnalyticsState, AnalyticsStateModel } from '../../../common/store/analytics/analytics.state';
import { analyticsStateConfig } from '../../../common/store/analytics/analytics-state.config';
import { State } from '@ngxs/store';
import { MDLA_SCOPE, MDLAScope } from '../../../common/shared/tokens/mdla-scope.token';

@State<AnalyticsStateModel>({ ...analyticsStateConfig, name: 'namAnalytics' })
@Injectable()
export class NamAnalyticsState extends AnalyticsState {
    public override stateScope: MDLAScope = inject(MDLA_SCOPE);
}
